import { JOB_STATUS, RELEASE_MODE_BLOCKED, VALIDATION_STATUS } from "@/constants/jobConstants";
import { PUBLISHING, UP_DOMAIN } from "@/constants/commonConstants";
import { RELEASE_JOB_TYPE } from "@/constants/releaseConstants";

//based on meeting with Zhimon, the ACCESS team wants to show ACCESS in Access as an update 
export const BLOCKED_RELEASE_PLC = ["ODIS", "AGS"];

// Helper function to flatten and filter targets
export const flattenAndFilterTargets = (targets: any[]): any[] => {
  if (!targets || !Array.isArray(targets)) {
    return [];
  }

  return (
    targets
      .flatMap((targetParent: any) => targetParent?.Targets || [])
      // Targeted not present or Targeted is true both are same
      .filter((target: any) => !target.hasOwnProperty("Targeted") || target.Targeted === true)
  );
};

export const filterDownloadUrls = (urls: Array<string>) => {
  return Array.isArray(urls) && urls?.length ? urls.filter((el) => !el.includes(UP_DOMAIN)) : urls;
};

export const isCreateReleaseVisible = (JobInfo: any, userProfile: any, admin = false) => {
  const contacts = JobInfo?.contact?.map((c: any) => c.Email);
  if (!isOwnerOrColloaborator(JobInfo, userProfile) && !admin) {
    return false;
  }
  if (JobInfo.dryrun || !(JobInfo?.job_status == JOB_STATUS.COMPLETED || JobInfo?.job_status == JOB_STATUS.RELEASED)) {
    return false;
  }
  if ([VALIDATION_STATUS.NOT_VALIDATED, VALIDATION_STATUS.IN_VALIDATION].includes(JobInfo.validation_status)) {
    return false;
  }

  if ([RELEASE_JOB_TYPE.FILE, RELEASE_JOB_TYPE.FILE_2, RELEASE_JOB_TYPE.CONFIG_FILE].includes(JobInfo?.image_type)) {
    return false;
  }

  if (JobInfo?.image_type === PUBLISHING.FILE || JobInfo?.image_type === PUBLISHING.BADGE_ICON) {
    return false;
  }

  if (BLOCKED_RELEASE_PLC.includes(JobInfo?.plc?.toUpperCase())) {
    return false;
  }
  return true;
};

// The jobs API reports release_mode; some modes don't permit creating a release from the portal.
// Casing varies across the jobs APIs, and records without the field predate the backend rollout,
// so an absent value stays releasable.
export const isReleaseModeBlocked = (JobInfo: any) => {
  const releaseMode = JobInfo?.release_mode ?? JobInfo?.releaseMode ?? JobInfo?.ReleaseMode ?? JobInfo?.RELEASE_MODE;
  if (!releaseMode) {
    return false;
  }
  const mode = String(releaseMode).toLowerCase();
  return RELEASE_MODE_BLOCKED.some((blocked) => blocked === mode);
};

export const saveFiltertoLocalStorage = (filter: any, tableMode: string) => {
  let filterData: any = {};
  let filterJobStr = localStorage.getItem(`${tableMode}_FILTER`);
  if (filterJobStr) {
    filterData = JSON.parse(filterJobStr);
  }

  for (const key in filter) {
    if (filterData[`${key}`]) {
      filterData[`${key}`] = filter[key];
      continue;
    }
    Object.assign(filterData, { [key]: filter[key] });
  }

  localStorage.setItem(`${tableMode}_FILTER`, JSON.stringify(filterData));
};

export const isOwnerOrColloaborator = (JobInfo: any, userProfile: any) => {
  const contacts = JobInfo?.contact?.map((c: any) => c.Email?.toLowerCase());
  if (contacts?.includes(userProfile?.emailId?.toLowerCase())) {
    return true;
  }
  return false;
};

export const checkPermissionForRelease = (admin: boolean, env: string) => {
  // TODO: Remove this function as we are allowing all users to release jobs.
  return true;
};

export const isLocalPath = (path: string) => {
  return typeof path === "string" && !path.includes("://") && path.startsWith("/");
};

export const isS3Path = (path: string) => {
  return typeof path === "string" && path.includes("://") && (path.startsWith("s3://") || path.startsWith("s3a://"));
};

export const isProductOrMajorUpgrade = (imageType: string) => {
  return [RELEASE_JOB_TYPE.PRODUCT, RELEASE_JOB_TYPE.PRODUCT_MAJOR_UPGRADE].includes(imageType);
};

export const shouldShowIgnoreValidationPopup = (JobInfo: any, multipleImages: any) => {
  return (
    JobInfo.validation_status == VALIDATION_STATUS.FAILED || multipleImages.some((image: any) => image.validation_status == VALIDATION_STATUS.FAILED)
  );
};

// Validation failures that may only be skipped by admins (e.g. unsigned binaries are a security concern).
export const ADMIN_ONLY_SKIP_VALIDATION_MESSAGES = [
  "Product Installation Fails with Error 1644",
  "Product Installation Fails with Error 1603"
];

export const requiresAdminToSkipValidation = (validationError?: string | null) => {
  const error = validationError ?? "";
  return ADMIN_ONLY_SKIP_VALIDATION_MESSAGES.some((message) => error.includes(message));
};
